var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignupWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 704,
    height: 702,
    viewBox: "0 0 704 702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16029",
    "data-name": "Rectangle 16029",
    width: 704,
    height: 702,
    transform: "translate(-18950 4545)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_8",
    x: -67.76,
    y: -267.87,
    width: 809.455,
    height: 1040.041,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Signup_2",
    "data-name": "Signup 2",
    transform: "translate(18950 -4545)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38252",
    "data-name": "Group 38252",
    transform: "translate(-18950.26 4340.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M403.979,905.04H52.207V0H373.18a111.117,111.117,0,0,1,27.479,3.444,108.87,108.87,0,0,1,25.179,9.887A104.962,104.962,0,0,1,447.49,28.99a100.4,100.4,0,0,1,16.9,20.762l201.77,330.18a98.816,98.816,0,0,1,6.1,11.617,88.019,88.019,0,0,1,4.23,11.784,84.377,84.377,0,0,1,2.424,11.984,87.421,87.421,0,0,1,.682,12.219,105.651,105.651,0,0,1-3.612,25.278,159.735,159.735,0,0,1-9.823,26.626L495.186,855.288a72.833,72.833,0,0,1-15.41,22.584,83.218,83.218,0,0,1-21.817,15.457C442.552,900.991,423.886,905.04,403.979,905.04Zm-379.411,0h0Z",
    transform: "translate(24.961 0)",
    fill: "#0f62eb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0.26, 204.31)",
    filter: "url(#Subtraction_8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8-2",
    "data-name": "Subtraction 8",
    d: "M398.78,905.04H0V0H367.981A111.118,111.118,0,0,1,395.46,3.444a108.877,108.877,0,0,1,25.179,9.887A104.96,104.96,0,0,1,442.291,28.99a100.405,100.405,0,0,1,16.9,20.762l201.77,330.18a93.19,93.19,0,0,1,10.35,23.49,86.558,86.558,0,0,1,3.139,24.352,104.524,104.524,0,0,1-3.605,25.308,151.21,151.21,0,0,1-9.884,26.359L489.987,855.288a77.572,77.572,0,0,1-15.706,21.693A90.511,90.511,0,0,1,452.5,892.537a110.186,110.186,0,0,1-25.841,9.37A124.452,124.452,0,0,1,398.78,905.04Z",
    transform: "translate(-0.26 -203.37)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupWhite);
export default __webpack_public_path__ + "static/media/signup_white.fdc6c698ed71da3f329fa2d88c989545.svg";
export { ForwardRef as ReactComponent };